import React, { useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import { FiArrowLeftCircle, FiArrowRightCircle, FiEdit, FiTrash2 } from 'react-icons/fi';
import { AiFillLike, AiOutlineLike } from 'react-icons/ai';
import { FaRegCommentAlt } from 'react-icons/fa';
import { green } from 'colors';
import './styles.css';
import Linkify from 'linkifyjs/react';

import * as linkify from 'linkifyjs';
import hashtag from 'linkifyjs/plugins/hashtag';


import { Link, useHistory } from 'react-router-dom';

import FeedLayout from '../Includes/FeedLayout';
import ProfileChips from '../Includes/ProfileChips';
import api from '../../services/api';
import Perfil from '../../assests/perfil.jpg';
import { calculaTempo } from '../../global';

import './styles.css';

import { useTranslation } from 'react-i18next';

const USER_EMAIL = sessionStorage.getItem('email');
const USER_TOKEN = sessionStorage.getItem('token');
const BASE_URL = sessionStorage.getItem('BASE_URL');

hashtag(linkify);
export default function Publicacoes() {
  const history = useHistory();
  const { t } = useTranslation();
  function proxima() {
    setPage(page + 1);
  }
  function anterior() {
    if (page > 1) {
      setPage(page - 1);
    }
  }
  const [page, setPage] = useState(1);

  const [posts, setPosts] = useState([]);
  const [atualiza, setAtualiza] = useState('');
  let nav;

  useEffect(() => {
    api.get(`v4/users/me/posts?page=${page}`, {
      headers: {
        'USER_EMAIL': sessionStorage.getItem('email'),
        'USER_TOKEN': sessionStorage.getItem('token'),
        'PARAMS': '',
        'Content-Type': 'application/json'
      }
    }).then(response => {
      setPosts(response.data);
      setAtualiza(Math.floor(Math.random() * 65536));
    }).catch(err => {
      if (err.status === 401) {
        history.push('/');
      }
    });
  }, [history, page])

  function Navegacao(props) {
    if (props.qtde >= 10) {
      return (
        <section className="paginacao">
          <div className="anterior">
            <span onClick={anterior}><FiArrowLeftCircle /> {t('commons.buttons.previous')} </span>
          </div>
          <div className="proxima">
            <span onClick={proxima}> {t('commons.buttons.next')} <FiArrowRightCircle /></span>
          </div>
        </section>
      )
    } else {
      return <p></p>
    }
  }
  function curtir(id, evaluation) {
    evaluation === null ? evaluation = true : evaluation = null;
    var axios = require('axios');
    var data = JSON.stringify({ "evaluation": evaluation });
    var config = {
      method: 'post',
      url: BASE_URL + `/v6/posts/${id}/evaluate`,
      headers: {
        'Content-Type': 'application/json',
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN
      },
      data: data
    };
    axios(config)
      .then(function (response) {
        // setTimeout(function () {
        //   setAtualiza(Math.floor(Math.random() * 65536));
        // }, 500);
        api.get(`v4/users/me/posts?page=${page}`, {
          headers: {
            'USER_EMAIL': sessionStorage.getItem('email'),
            'USER_TOKEN': sessionStorage.getItem('token'),
            'PARAMS': '',
            'Content-Type': 'application/json'
          }
        }).then(response => {
          setPosts(response.data);
          setAtualiza(Math.floor(Math.random() * 65536));
        }).catch(err => {
          if (err.status === 401) {
            history.push('/');
          }
        });
      })
      .catch(function (error) {
      });

  }
  // function Like(props) {
  //   var evaluation = props.evaluation;
  //   if (evaluation === true) {
  //     evaluation = true;
  //     return (
  //       <button onClick={() => curtir(props.id, evaluation)}>
  //         <AiFillLike size={18} color="green" />
  //         <span className="like">{props.count}</span>
  //       </button>
  //     )
  //   } else {
  //     evaluation = null;
  //     return (
  //       <button onClick={() => curtir(props.id, evaluation)}>
  //         <AiFillLike size={18} color="#DAD9E2" />
  //         <span className="like">{props.count}</span>
  //       </button>

  //     )
  //   }

  // }

  function Like(props) {
    var evaluation = props.evaluation;
    if (evaluation === true) {
      evaluation = true;
      return (
        <button type="button" onClick={() => curtir(props.id, evaluation)}>
          <AiFillLike size={18} color="#00b8ff" />
          <span className="like">{props.count}</span>
        </button>
      )
    } else {
      evaluation = null;
      return (
        <button type="button" onClick={() => curtir(props.id, evaluation)}>
          <AiOutlineLike size={18} color="#6b7280" />
          <span className="like">{props.count}</span>
        </button>

      )
    }

  }

  function alterarPublicacao(postId) {
    const result = posts.find(post => post.id === postId);
    sessionStorage.setItem('publicacao', JSON.stringify(result));
    history.push(`/publicacao/alterar/${postId}`)
  }
  function excluirPublicacao(id) {
    var excl = window.confirm(t('commons.messages.deleteConfirmation'));
    if (!excl) {
      return false;
    }
    var axios = require('axios');
    var FormData = require('form-data');
    var data = new FormData();

    var config = {
      method: 'delete',
      url: BASE_URL + `/v4/users/me/posts/${id}`,
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
      },
      data: data
    };
    axios(config)
      .then(function (response) {
        history.go(0);
      })
      .catch(function (error) {
      });
  }
  function mostrarEditar(post) {
    return (
      <div className="edit"><Link to="#" onClick={() => alterarPublicacao(post.id)}>
        <FiEdit />{t('pages.publications.buttons.edit')}</Link>
        <Link className="icoExcluir" to="#" onClick={() => excluirPublicacao(post.id)}>
          <FiTrash2 className="icoExcluir" />{t('pages.publications.buttons.delete')}
        </Link>
      </div>
    )
  }

  function verificaHach(text) {
    //var repl = text.replace(/#(\w+)/g, '<a href="#">#$1</a>');
    var repl = text.replace(/#(\w+)/g, '#$1');
    return repl;
  }


  var linkifyOptions = 
  {
      formatHref: function (href, type) {
        if (type === 'hashtag') {
          href = '#' + href.substring(1);
        }
        return href;
      }
    }
  return (
    <FeedLayout active="profile">
    <div className="publicacao-container">
      <div className="feed-top">{t('pages.publications.title')}</div>
      <ProfileChips active="publications" />
      <Navegacao qtde={posts.length} />

      <section className="body">
        <ul>
          {
            posts.map(post => (

              <li key={post.id}>
                {mostrarEditar(post)}
                <p className="nomeProf"><img className="imgProf" src={post.user.avatar.medium === null ? Perfil : post.user.avatar.medium} alt={t('pages.publications.alt.profile')} /><span className="nome">{post.user.name}</span><span className="tempo">  -  {calculaTempo(post.created_at)}</span></p>
                <div className="containerTag">
                  <p className="tags">
                    {post.tags.map(tag => (
                      <div className="clTag"><span>{tag.name}</span></div>
                    ))
                    }
                  </p>
                </div>
                <p className="title">{post.title}</p>
                <Linkify className="description" options={linkifyOptions}>{post.description}</Linkify>
                
                {/* <p className="description">{verificaHach(post.description)}</p> */}
                {/* <p className="lermais">CONTINUAR LENDO</p> */}
                <p className="icons">
                  <Like count={post.ups_count} id={post.id} evaluation={post.evaluation} />
                  <span className="coment"><FaRegCommentAlt size={18} color="#6b7280" /><span className="like">{parseInt(post.first_comments.length)}</span></span>
                </p>
              </li>
            ))}
        </ul>
      </section>
      <Navegacao qtde={posts.length} />
    </div>
    </FeedLayout>
  )
}